import { useEffect } from 'react';
import dedent from 'ts-dedent';

export function useControlledWarning({
  activeTabId,
  defaultActiveTabId,
}: {
  activeTabId?: string;
  defaultActiveTabId?: string;
}) {
  useEffect(() => {
    if (activeTabId !== undefined && defaultActiveTabId !== null) {
      // eslint-disable-next-line no-console
      console.error(
        dedent`
          Both 'activeTabId' (controlled component) and
          'defaultActiveTabId' (uncontrolled) should not be
          used at the same time.
          This will lead to unexpected behavior.
        `,
      );
    }
  }, [
    activeTabId,
    defaultActiveTabId,
  ]);
}
